import { getGraphqlResponseData } from "../../middleware/middleware";
import {
  availableStylist,
  stylistCombo,
} from "../../graphql/query/availableStylist";
import { isArray } from "lodash";
import {
  FETCH_STYLIST_CARD_DATA,
  FETCH_STYLIST_CARD_DATA_SUCCESS,
  FETCH_STYLIST_CARD_DATA_FAILURE,
  FETCH_STYLIST_CARD_DATA_WITHOUT_TIME,
  FETCH_STYLIST_CARD_DATA_UPDATE_ERROR,
} from "./types";

import {
  getSelectedStylistData,
  getSelectedStylistDataWithoutDate,
  getDiasbleTime,
} from "../../utils/helper/helper";
import { getSelectedStylist } from "../../actions/appointments/appointments";
import { store } from '../../store';

export const fetchStylistData = (data) => {
  return {
    type: FETCH_STYLIST_CARD_DATA,
    data,
  };
};

export const fetchStylistDataSuccess = (data) => {
  return {
    type: FETCH_STYLIST_CARD_DATA_SUCCESS,
    data,
  };
};

export const fetchStylistDataFailure = (data) => {
  return {
    type: FETCH_STYLIST_CARD_DATA_FAILURE,
    data,
  };
};

export const hasTimeAvaialble = (data) => {
  return {
    type: FETCH_STYLIST_CARD_DATA_WITHOUT_TIME,
    data,
  };
};

export const updateErrorMessage = (data, message) => {
  return {
    type: FETCH_STYLIST_CARD_DATA_UPDATE_ERROR,
    data,
    message,
  };
};

const modifiedData = (data) => {
  let res = data.map((each) =>
    isArray(each)
      ? each.filter(
          (element) =>
            element?.availableDays && Object.keys(element.availableDays).length
        )
      : Object.keys(each.availableDays).length
  );
  const getData = res.filter((eachval) => eachval.length > 0);

  return getData;
};

export const getStylistDataWithMonth =
  ({
    selectedStore,
    selectedServices,
    startDay,
    endDay,
    selectedStylist,
    isdateSelected = false,
    editAppointmentId,
    hasImage = false,
    isStylistFlow = false
  }) =>
  async (dispatch) => {
    dispatch(fetchStylistData(true));

    const payload = {
      method: "post",
      url: `/graphql`,
      headers: {
        "Content-Type": "application/json",
      },
      data: availableStylist(
        selectedStore,
        selectedServices,
        startDay,
        endDay,
        selectedStylist,
        null,
        editAppointmentId,
        isStylistFlow
      ),
    };
    const graphqlData = await getGraphqlResponseData(payload);

    if (
      graphqlData?.status === 200 &&
      graphqlData?.data?.data?.stylistWithAvailableDays
    ) {
      const getData = modifiedData(
        graphqlData.data.data.stylistWithAvailableDays
      );

      if (isdateSelected) {
        const selectedStylistData = getSelectedStylistData(
          getData,
          isdateSelected,
          selectedStylist
        );
        dispatch(getSelectedStylist(selectedStylistData));
      }
      if (hasImage) {
        const selectedStylistData = getSelectedStylistDataWithoutDate(
          getData,
          selectedStylist
        );
        dispatch(getSelectedStylist(selectedStylistData));
      }

      dispatch(fetchStylistDataSuccess(getData));
      dispatch(fetchStylistData(false));
    } else {
      dispatch(fetchStylistData(false));

      dispatch(fetchStylistDataSuccess(null));
      dispatch(fetchStylistDataFailure(true));
    }
  };

export const getStylistDataWithoutTime =
  ({ selectedStore, selectedServices, startDay, timeZone }) =>
  async (dispatch) => {
    dispatch(fetchStylistData(true));
    dispatch(hasTimeAvaialble(false));
    const payload = {
      method: "post",
      url: `/graphql`,
      headers: {
        "Content-Type": "application/json",
      },
      data: stylistCombo(selectedStore, selectedServices, startDay, timeZone),
    };
    const graphqlData = await getGraphqlResponseData(payload);
    if (graphqlData?.status === 200 && graphqlData?.data?.data?.stylistCombo) {
      dispatch(fetchStylistData(false));
      dispatch(hasTimeAvaialble(true));
      dispatch(fetchStylistDataSuccess(graphqlData.data.data.stylistCombo));
    } else {
      dispatch(fetchStylistData(false));
      dispatch(fetchStylistDataFailure(true));
      dispatch(fetchStylistDataSuccess(null));
      dispatch(hasTimeAvaialble(false));
    }
  };

// Retrieving the stylist card data from redux state
export const getStylistDataFromState = () => store.getState()?.stylist?.stylistCard || [];

// fetching all the stylist combination regardless of their availability for the selected services
export const fetchUnAvailableStylist = async ({
 selectedStore, selectedServices, startDay, restrictTeammate, 
}) => {
  const payloadWithoutTime = {
    method: 'post',
    url: `/graphql`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: stylistCombo(selectedStore, selectedServices, startDay, null, null, restrictTeammate),
  };

  const graphqlDataWithoutTime = await getGraphqlResponseData(payloadWithoutTime);
  return graphqlDataWithoutTime;
};

// fetch all the availabe stylist combination for the selected services
export const getAvailableStylistData = ({
  selectedStore, selectedServices, startDay, endDay, selectedStylist, partoftheday, restrictTeammate = true,
}) => async (dispatch) => {
  dispatch(fetchStylistData(true));
  dispatch(hasTimeAvaialble(false));
  let partofthedays;
    if (partoftheday && partoftheday.length > 0) {
      if (partoftheday.length === 3) {
        partofthedays = null;
      } else {
        partofthedays = partoftheday;
      }
    } else if (partoftheday === 'all') {
      partofthedays = null;
    } else {
      partofthedays = null;
    }
    const payload = {
      method: 'post',
      url: `/graphql`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: availableStylist(
        selectedStore,
        selectedServices,
        startDay,
        endDay,
        selectedStylist,
        partofthedays,
        null,
        null,
        restrictTeammate,
      ),
    };

    const graphqlData = await getGraphqlResponseData(payload);
    if (graphqlData?.status === 200 && graphqlData?.data?.data?.stylistWithAvailableDays) {
      let hasError = false;
      const getData = modifiedData(graphqlData.data.data.stylistWithAvailableDays);
      if (getData?.length === 0) {
        const graphqlDataWithoutTime = await fetchUnAvailableStylist({selectedStore, selectedServices, startDay, restrictTeammate: true});
        const stylistComboData = graphqlDataWithoutTime?.data?.data?.stylistCombo || [];
        // Set the error state when api returns 500
        hasError = stylistComboData?.length === 0 && graphqlDataWithoutTime?.data?.errors && graphqlDataWithoutTime?.data?.errors[0];
        dispatch(hasTimeAvaialble(true));
        dispatch(hasError ? updateErrorMessage(true, graphqlDataWithoutTime?.data?.errors[0]?.message) : fetchStylistDataSuccess(stylistComboData));
      } else {
        const getTimedata = getDiasbleTime(getData, selectedStore?.timezone, startDay);
        dispatch(fetchStylistDataSuccess(getTimedata));
      }
      if (!hasError) {
        dispatch(fetchStylistData(false));
      }
    } else {
      dispatch(fetchStylistData(false));
      dispatch(fetchStylistDataSuccess(null));
      dispatch(fetchStylistDataFailure(true));
    }
};  

export const getStylistData = ({
    selectedStore,
    selectedServices,
    startDay,
    endDay,
    isEditable = false,
    selectedStylist,
    partoftheday = null,
    restrictTeammate = true,
  }) => async (dispatch) => {
    dispatch(fetchStylistData(true));
    const graphqlDataWithoutTime = await fetchUnAvailableStylist({ selectedStore, selectedServices, startDay, restrictTeammate });
    const availableStylistData = getStylistDataFromState();
    let hasError = false;
    if (graphqlDataWithoutTime?.status === 200 && graphqlDataWithoutTime.data.data.stylistCombo) {
      if (isEditable) {
        const stylistComboData = graphqlDataWithoutTime?.data?.data?.stylistCombo;

        const finalStylistList = stylistComboData ? availableStylistData.concat((stylistComboData).filter((stylist) => (availableStylistData.findIndex((stylistTime) => {
          for (let index = 0; index < stylist.length; index++) {
            if (stylistTime[index].teammateId !== stylist[index].teammateId) {
              return false;
            }
          }
          return true;
        })) < 0)) : availableStylistData;

        hasError = finalStylistList?.length === 0 && graphqlDataWithoutTime?.data?.errors && graphqlDataWithoutTime?.data?.errors[0];
        dispatch(hasError ? updateErrorMessage(true, graphqlDataWithoutTime?.data?.errors[0]?.message) : fetchStylistDataSuccess(finalStylistList));
      } else {
        dispatch(fetchStylistDataSuccess(availableStylistData));
      }
      if (!hasError) {
        dispatch(fetchStylistData(false));
      }
    } else {
      dispatch(fetchStylistData(false));
      dispatch(fetchStylistDataSuccess(null));
      dispatch(fetchStylistDataFailure(true));
      graphqlDataWithoutTime?.data?.errors && graphqlDataWithoutTime?.data?.errors[0] && dispatch(updateErrorMessage(true, graphqlDataWithoutTime?.data?.errors[0]?.message));
    }
  };

export const removeStylistcard = () => async (dispatch) => {
  dispatch(fetchStylistDataSuccess(null));
};
